import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";

// Utils
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const TagsGroupTable = ({ dispatch, userName, companyName, onOpenFilterModal, appliedFilters = {} }) => {
	const defaultParams = { page: 1, orderKey: "count", orderDir: "desc", rows: 25 };
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastParams, setLastParams] = useState(defaultParams);
	const [sumData, setSumData] = useState({});

	useEffect(() => {
		const mergedParams = {
			...defaultParams,
			...appliedFilters,
			groupBy: "groupId",
		};

		(async () => {
			try {
				const response = await dataHandler({
					dispatch,
					method: "GET",
					url: "/reports/historic/tags",
					params: mergedParams,
				});
				const formattedSumData = {
					count: response.total?.total || 0,
					percent: response.total?.percent || "0%",
				};
				setFilteredItems(response.items);
				setFilteredCount(response.count);
				setSumData(formattedSumData);
				setLastParams(mergedParams);
			} catch (error) {
				setFilteredItems([]);
				setFilteredCount(0);
				setSumData({});
			}
		})();
	}, [appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		const mergedParams = {
			...params,
			...appliedFilters,
			groupBy: "groupId",
			fields: "tag.name,chat:group.name",
		};

		const data = await dataHandler({
			method: "GET",
			dispatch,
			url: "/reports/historic/tags",
			params: mergedParams,
		});
		const formattedSumData = {
			count: data.total?.total || 0,
			percent: data.total?.percent || "0%",
		};

		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setLastParams(mergedParams);
			setSumData(formattedSumData);
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const renderTopButtons = () => {
		const hasFilters = Object.keys(appliedFilters || {}).length > 0;
		const filterText = hasFilters ? "Filtrando" : "";

		const buttons = [
			{
				icon: "filter",
				className: hasFilters ? styles.filterButtonActive : styles.filterButton,
				onClick: onOpenFilterModal,
				content: filterText,
				label: filterText,
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];

		const dateRange =
			appliedFilters?.createdDate || appliedFilters?.closeDate || appliedFilters?.["chat.closeDate"] || appliedFilters?.date;
		if (dateRange) {
			const formatD = (d) => {
				if (!d) return "";
				const parts = d.split("-");
				if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
				if (parts.length === 2) return `${parts[1]}/${parts[0]}`;
				return d;
			};
			const [start, end] = dateRange.split(",");
			let value = formatD(start);
			const today = new Date();
			const currentEnd =
				end || `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
			if (currentEnd && start !== currentEnd) value += ` al ${formatD(currentEnd)}`;

			buttons.push({
				componentType: "Label",
				title: "Fecha:",
				value,
			});
		}

		return buttons;
	};

	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Grupos",
								key: "chat.group.name",
								format: "string",
								headerPosition: "center",
								dataPosition: "left",
								width: 1,
							},
							{
								label: "Etiquetas",
								key: "tag.name",
								format: "string",
								headerPosition: "center",
								// canSort: false,
								dataPosition: "left",
								width: 2,
							},
							{
								label: "Cantidad",
								key: "count",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
								sum: true,
							},
							{
								label: "%",
								key: "percent",
								format: "string",
								headerPosition: "left",
								dataPosition: "left",
								width: 15,
								sum: true,
							},
						]}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						print={{
							printHeader: {
								company: companyName,
								title: "Etiquetas Grupo",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
						sumData={sumData}
					/>
				</div>
			</div>
		</div>
	);
};
function mapStateToProps({ user, company }) {
	return {
		userName: user.name,
		companyName: company.name,
	};
}

TagsGroupTable.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect(mapStateToProps)(TagsGroupTable);
